import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { buildApiUrl } from '../config/api';
import '../styles/index.css';

const SignupPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(buildApiUrl('/api/signup'), {
        User_ID: values.User_ID,
        User_PW: values.User_PW,
        User_Name: values.User_Name, // 이름을 서버에 User_Name으로 보냄
      });

      // 성공 여부를 status 코드로 체크
      if (response.status === 200) {
        message.success('회원가입이 완료되었습니다! 로그인 해주세요.');
        navigate('/'); // 회원가입 후 로그인 페이지로 이동
      } else {
        message.error('회원가입 실패: ' + (response.data.message || '알 수 없는 오류가 발생했습니다.'));
      }
    } catch (error) {
      message.error('회원가입 중 오류가 발생했습니다: ' + (error.response?.data?.message || error.message));
      console.error('Signup error:', error);
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const validatePassword = (_, value) => {
    if (!value || value.length >= 4) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('비밀번호는 최소 4자리 이상이어야 합니다.'));
  };

  // 취소 버튼 클릭 시 로그인 페이지로 이동
  const handleCancel = () => {
    navigate('/');
  };

  return (
    <div className="login-container">
      <div className="signup-box">
        <Form
          form={form}
          name="signup"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ width: 400 }}
        >
          <Form.Item
            label="아이디"
            name="User_ID"
            rules={[{ required: true, message: '아이디를 입력해주세요!' }]}
          >
            <Input autoComplete="username" />
          </Form.Item>

          <Form.Item
            label="비밀번호"
            name="User_PW"
            rules={[
              { required: true, message: '비밀번호를 입력해주세요!' },
              { validator: validatePassword },
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label="비밀번호 확인"
            name="confirmPassword"
            dependencies={['User_PW']}
            hasFeedback
            rules={[
              { required: true, message: '비밀번호를 다시 입력해주세요!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('User_PW') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('비밀번호가 일치하지 않습니다!'));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>

          <Form.Item
            label="이름"
            name="User_Name"
            rules={[{ required: true, message: '이름을 입력해주세요!' }]}
          >
            <Input autoComplete="name" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                회원가입
              </Button>
              <Button type="default" onClick={handleCancel}>
                취소
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SignupPage;
